module.exports = __webpack_public_path__ + "static/media/progger4.593d3e41.png";